import React from "react";
import { compose, withAppContext, withActions } from "containers/HOC";
import { Form, Field } from "react-final-form";
import { FieldArray } from "react-final-form-arrays";
import arrayMutators from "final-form-arrays";
import * as FormUtils from "common/FormUtils";
import * as utils from "common/utils";
import Modal from "components/new/Modal";
import ModalBody from "components/new/ModalBody";
import ModalFooter from "components/new/ModalFooter";
import Grid from "components/Grid";
import GridCell from "components/GridCell";
import InputPack from "components/InputPack";
import BlockSelector from "components/new/BlockSelector";
import { closeModal } from "containers/App/_actions";

const SEASON_NAMES = ["Spring", "Summer", "Autumn", "Winter"];

class OutdoorPigGreenCoverApplicationModal extends React.Component {
    validate = (viewModel) => {
        const error = {};
        if (!viewModel.blockIds || viewModel.blockIds.length === 0) error.blockIds = "Required";
        return error;
    };

    onSubmit = (viewModel) => {
        delete viewModel.availableBlocks;
        this.props.modal.onConfirm(viewModel);
        this.props.closeModal();
    };

    validateSeasons = (seasons) => {
        const errors = [];

        seasons &&
            seasons.forEach((season) => {
                const error = {};
                error.percentage = FormUtils.validators.max(100)(season.percentage);
                errors.push(error);
            });

        return errors;
    };

    render() {
        const { viewModel } = this.props;

        return (
            <Form initialValues={viewModel} mutators={{ ...arrayMutators }} validate={this.validate} onSubmit={this.onSubmit}>
                {({ form, values, handleSubmit, submitting, submitSucceeded }) => {
                    const disableSave = submitSucceeded || submitting;

                    return (
                        <Modal title="Outdoor pigs seasonal green cover" allowOffline={true}>
                            {({ closeModal }) => (
                                <form onSubmit={handleSubmit}>
                                    <ModalBody>
                                        <Grid>
                                            <GridCell>
                                                <Field name="blockIds" availableBlocks={viewModel.availableBlocks} component={BlockSelector} />
                                            </GridCell>
                                            <GridCell>
                                                <h3>Seasonal green cover</h3>
                                                <p className="u-mt-md">Enter the percentage of green cover for each season for each animal class."</p>
                                                <div className="FarmTable-supplementary u-mt-md">
                                                    <div className="Table">
                                                        <table>
                                                            <thead>
                                                                <tr>
                                                                    <th data-width="15"></th>
                                                                    {SEASON_NAMES.map((seasonName) => (
                                                                        <th key={seasonName} className="th--shrink">
                                                                            {seasonName}
                                                                        </th>
                                                                    ))}
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <FieldArray name="applications">
                                                                    {({ fields }) => {
                                                                        return fields.map((applicationField, applicationIndex) => {
                                                                            const application = fields.value[applicationIndex];
                                                                            const stockClassGroupDisplayText = utils.getOutdoorPigStockClassGroupDisplayText(application.stockClassGroup);

                                                                            return (
                                                                                <tr key={application.stockClassGroup}>
                                                                                    <td className="u-textBold">{stockClassGroupDisplayText}</td>
                                                                                    <FieldArray name={`${applicationField}.seasons`} validate={this.validateSeasons}>
                                                                                        {({ fields }) => {
                                                                                            return fields.map((seasonField, seasonIndex) => {
                                                                                                const season = fields.value[seasonIndex];
                                                                                                return (
                                                                                                    <td key={season.season}>
                                                                                                        <Field name={`${seasonField}.percentage`} noLabel uom="%" placeholder="0" type="text" component={InputPack} format={FormUtils.formatters.formatInt} formatOnBlur />
                                                                                                    </td>
                                                                                                );
                                                                                            });
                                                                                        }}
                                                                                    </FieldArray>
                                                                                </tr>
                                                                            );
                                                                        });
                                                                    }}
                                                                </FieldArray>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </GridCell>
                                        </Grid>
                                    </ModalBody>
                                    <ModalFooter>
                                        <div className="ButtonBar">
                                            <div className="ButtonBar-left">
                                                <button id="cancel-button" type="button" className="Button Button--secondary" onClick={closeModal}>
                                                    Cancel
                                                </button>
                                            </div>
                                            <div className="ButtonBar-right">
                                                <button id="done-button" type="submit" className="Button" disabled={disableSave}>
                                                    Done
                                                </button>
                                            </div>
                                        </div>
                                    </ModalFooter>
                                </form>
                            )}
                        </Modal>
                    );
                }}
            </Form>
        );
    }
}
export default compose(withAppContext, withActions({ closeModal }))(OutdoorPigGreenCoverApplicationModal);
